import { render } from "./AuthPref.vue?vue&type=template&id=032129e6&scoped=true&ts=true"
import script from "./AuthPref.vue?vue&type=script&lang=ts"
export * from "./AuthPref.vue?vue&type=script&lang=ts"

import "./AuthPref.vue?vue&type=style&index=0&id=032129e6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032129e6"]])

export default __exports__